/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ walkIn: NonNullable<unknown> }} Customer_Search_Walk_In_HintInputs */

const vi_customer_search_walk_in_hint = /** @type {(inputs: Customer_Search_Walk_In_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tìm theo tên hoặc SĐT. Bỏ trống sẽ là ${i?.walkIn}.`)
};

/**

* @param {Customer_Search_Walk_In_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_search_walk_in_hint = /** @type {((inputs: Customer_Search_Walk_In_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Search_Walk_In_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_search_walk_in_hint(inputs)
});